// import { CSSProperties } from 'react';
import { Card, Col } from 'react-bootstrap';
// import { TextToHTML } from "@victorequena22/slate-bootstrap";
import { State } from '../index';
import { EventoLista } from '../../../../Capacitacion/Evento/Models';
import { findProgram } from '../../../../Capacitacion/Context/Programas';
interface Props {
    iten: EventoLista,
    config: State
}
export function Itens({ config: { gap, size }, iten: { short, programa: p } }: Props) {
    const s1 = ['990px', '1080px', '780px'];
    const s2 = ['1440px', '1320px'];
    const { short: s } = findProgram(p);
    return <Col style={{ margin: '0 0 0 0', padding: '0 0 0 0' }} xs={s2.some(s => size === s) ? 3 : s1.some(s => size === s) ? 4 : 6}>
        <Card style={{ margin: `0 ${gap}px 0 ${gap}px` }} className="c-content-person-1 c-option-2 mt-2">
            <Card.Img variant="top" src={short === '' ? s : short} />
        </Card>
    </Col >
}
